import { ProductAccountDTO } from 'api-models'

export type WorkspaceAccess =
	| 'full'
	| 'not-started'
	| 'no-setup'
	| 'no-ad-account'
	| 'cancelled'

/** Workspace history is authoritative; a new website or disconnected account never relocks access. */
export function resolveWorkspaceAccess(
	account: ProductAccountDTO
): WorkspaceAccess {
	const subscription = account.billing?.subscription
	const step = account.setup?.step
	if (
		!subscription?.type &&
		['ACCOUNT_CREATED', 'PLAN_SELECTED'].includes(step || '')
	)
		return 'not-started'
	if (subscription?.status === 'CANCELLED') return 'cancelled'
	if (subscription?.status === 'CANCELLING') return 'full'
	if (
		account.has_connected_ad_account ||
		['AD_ACCOUNT_CONNECTED', 'SETUP_COMPLETE'].includes(step || '')
	)
		return 'full'
	if (
		['ACCOUNT_CREATED', 'PLAN_SELECTED', 'TRIAL_STARTED'].includes(step || '')
	)
		return 'no-setup'
	if (step === 'WEBSITE_PROTECTED') return 'no-ad-account'
	// Legacy workspaces without the onboarding state retain their existing access.
	return 'full'
}
